module.exports = __webpack_public_path__ + "static/img/logo-yimian-white.c9f8626.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-yimian-white.png
// module id = 364
// module chunks = 1